export const CRM_STAGES = [
  { value: "new_lead", label: "New Lead", tone: "bg-blue-500/15 text-blue-300 border-blue-500/30" },
  { value: "contacted", label: "Contacted", tone: "bg-cyan-500/15 text-cyan-300 border-cyan-500/30" },
  { value: "quote_sent", label: "Quote Sent", tone: "bg-amber-500/15 text-amber-300 border-amber-500/30" },
  { value: "booked", label: "Booked", tone: "bg-emerald-500/15 text-emerald-300 border-emerald-500/30" },
  { value: "loyal", label: "Loyal", tone: "bg-rose-500/15 text-rose-300 border-rose-500/30" },
];

export const stageDetails = (value) =>
  CRM_STAGES.find((stage) => stage.value === value) || CRM_STAGES[0];

export const vehicleName = (customer) =>
  [customer.vehicle_year, customer.vehicle_make, customer.vehicle_model].filter(Boolean).join(" ") || "No vehicle saved";

export const formatMoney = (value) => `$${Number(value || 0).toLocaleString()}`;
